// extracted by mini-css-extract-plugin
export default {"root":"src__components__time-select__input__root","disable_mask":"src__components__time-select__input__disable_mask"};